import { useAppSelector } from "@/lib/store";

export const useAdministersActiveOrganization = (): boolean => useAppSelector((state) => state.membership.membership?.role === "admin");
